export const MISSING_BASKET_ERROR = "Basket is empty";
export const MISSING_CART_ERROR_MESSAGE = "Cart not found";
export const MISSING_NOVA_CART_ERROR_MESSAGE = "Cart undefined not found";
export const MISSING_GUEST_EMAIL_ERROR_MESSAGE = "Guest email not found";
